import apiCityCenter from "@/services/cityCenter/api/apiCityCenter";
const endpoints = require("../../common/endpoints");
import { handleError } from "@/store/shared";
import {
  SET_USER_CONTRACTS,
  SET_USER_PERMISSIONS,
  SET_KEYCLOAK,
  SET_USER,
  LOGOUT,
  SET_UN_CONSTRUCTED_USER_PERMISSIONS
} from "@/store/user/mutation-types";
import { storePermissionsInLocalStorage } from "@/services/cityCenter/login/loginService";
import { encryptObject } from "@/services/cityCenter/encryption/encryptionService";

const actions = {
  initKeycloak({ commit }, keycloak) {
    const keycloakObject = { ...keycloak };
    keycloakObject.idToken = encryptObject(keycloakObject?.idToken);
    keycloakObject.refreshToken = encryptObject(keycloakObject?.refreshToken);
    keycloakObject.token = encryptObject(keycloakObject?.token);
    commit(SET_KEYCLOAK, keycloakObject);
  },
  logIn({ commit }) {
    commit(SET_USER);
  },
  logOut({ commit }) {
    commit(LOGOUT);
  },
  async setUserContracts({ commit }, payload) {
    // console.log("setUserContracts().payload:", payload);
    return apiCityCenter
      .getWithoutPayload(endpoints.get_user_application_contract_list + payload)
      .then(response => {
        let data = response.data;
        commit(SET_USER_CONTRACTS, data);
      })
      .catch(error => handleError(error, `Unable to set User Contracts`));
  },
  async setUserPermissions({ commit }, payload) {
    // console.log("setUserPermissions().payload:", payload);
    return apiCityCenter
      .getWithoutPayload(endpoints.get_user_permissions + payload)
      .then(response => {
        const data = response.data;
        if (data.code === 200) {
          if (data.data !== null) {
            const [unConstructed, constructed] = storePermissionsInLocalStorage(
              data
            );
            commit(SET_USER_PERMISSIONS, constructed);
            commit(SET_UN_CONSTRUCTED_USER_PERMISSIONS, unConstructed);
          }
        }
      })
      .catch(error => handleError(error, `Unable to set User Permissions`));
  },
  setUnConstructedUserPermissions({ commit }, payload) {
    commit(SET_UN_CONSTRUCTED_USER_PERMISSIONS, payload);
  }
};

export default actions;
